import ExtendableError from 'es6-error';

class ResponseError extends ExtendableError {
    constructor(response) {
        super(`Response error "${response.status}" received from "${response.url}"`);
        this.response = response;
    }
}

export default ResponseError;
